import React from "react";

function OsanoLink() {
  return (
    <a
      href="#"
      style={{display: "block", marginTop: 32, fontWeight: "normal", textDecoration: "underline"}}
      onClick={() => Osano.cm.showDoNotSell()}
    >
      Do Not Share My Personal Information
    </a>
  );
}

export default OsanoLink;